import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getAppAndSitesCategoryTags(version: number, categories: string[]): TagItem[] {
  const result: TagItem[] = [];
  if (categories.length > 0) {
    result.push({ label: `IAB v.${version}` });
    result.push({ label: `${categories.length} categor${categories.length !== 1 ? 'ies' : 'y'}` });
  }

  return result;
}
